/* eslint-disable react/jsx-props-no-spreading */
import MaskUtils from 'commons/utils/maskUtils';
import React from 'react';
import { FormTextFieldWithMask } from '../FormikFields';

function FormTextFieldMaskedPhone(props) {
  const phoneMask = MaskUtils.getPhoneMask();
  return <FormTextFieldWithMask mask={phoneMask} {...props} />;
}

export default FormTextFieldMaskedPhone;
